import Vue from "vue";

Vue.component("static-content-collapse", {
	props: ["title", "children", "indexCollapse", "openIndexCollapse", "openIndexCollapseChild"],
	data() {
		return {
			content: "",
			loading: true
		};
	},
	computed: {
		loadingText() {
			return window.labels.loading + "..";
		},
	},
	methods: {
		getContent: function () {
			this.loading = true;
			this.$services.staticContents.getContent({
				code: this.title,
				language: window.currentLanguageInt
			})
				.then((data) => {
					this.loading = false;
					this.content = data.content;
				});
		},
		openInfo: function(){
			this.$emit('open-info', 'faq', this.indexCollapse)
		},
		openChildInfo: function (child) {
			this.$emit('open-info', 'faq', this.indexCollapse, child)
		}
	},
	mounted() {
		this.getContent();
	},
	template: `
      <b-collapse :open="openIndexCollapse == indexCollapse" @open="openInfo" class="notification card" animation="slide">
		  <template #trigger="props">
            <div v-if="loading" class="card-header" role="button">
              <loading :loading-text="loadingText"></loading>
            </div>
			<div v-else class="card-header" role="button">
			  <p class="card-header-title" v-html="content"></p>
			  <a class="card-header-icon"><b-icon pack="fas" :icon="props.open ? 'chevron-down' : 'chevron-up'"></b-icon></a>
			</div>
		  </template>
		  <div class="card-content">
			<div class="content">
			  <static-content-child-collapse v-for="(child, index) of children" 
				  :key="index"
				  @open-child-info="openChildInfo" 
				  :index-collapse.sync="index" 
				  :open-index-collapse.sync="openIndexCollapseChild" 
				  :parent-index.sync="indexCollapse"
				  :open-parent-index.sync="openIndexCollapse"
				  :title="child.title" 
				  :description="child.description">
			  </static-content-child-collapse>			  
			</div>
		  </div>
      </b-collapse>
	`
});